let BASE_URL = process.env.REACT_APP_API_URL || "";

if (!BASE_URL) {
  if (process.env.NODE_ENV === "development") {
    BASE_URL = "http://localhost:3002";
  } else {
    BASE_URL = "https://app.shopalli.com.br";
  }
}

BASE_URL += "/api";

const API = {
  AUTH: {
    LOGIN: `${BASE_URL}/auth/login`,
    REGISTER: `${BASE_URL}/auth/register`,
    ME: `${BASE_URL}/auth/me`,
    FORGOT_PASSWORD: `${BASE_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
  },
  COMPANIES: `${BASE_URL}/companies`,
  COMPANY_CONTACTS: (id) => `${BASE_URL}/companies/${id}/contacts`,
  COMPANY_DOCS: (id) => `${BASE_URL}/companies/${id}/documents`,
  COMPANY_CATEGORIES: (id) => `${BASE_URL}/companies/${id}/categories`,
  COMPANY_REGIONS: (id) => `${BASE_URL}/companies/${id}/regions`,
  CATEGORIES: `${BASE_URL}/categories`,
  REGIONS: `${BASE_URL}/regions`,
  ADS: `${BASE_URL}/ads`,
  AD: (id) => `${BASE_URL}/ads/${id}`,
  AD_STATUS: (id) => `${BASE_URL}/ads/${id}/status`,
  AD_CATEGORIES: (id) => `${BASE_URL}/ads/${id}/categories`,
  AD_REGIONS: (id) => `${BASE_URL}/ads/${id}/regions`,
  CHAT_CONVERSATIONS: `${BASE_URL}/chat/conversations`,
  CHAT_CONVERSATIONS_CUSTOMER: `${BASE_URL}/chat/conversations/customer`,
  CHAT_MESSAGES: (id) => `${BASE_URL}/chat/conversations/${id}/messages`,
  CHAT_MESSAGES_CUSTOMER: (id) => `${BASE_URL}/chat/conversations/${id}/messages/customer`,
};

export { BASE_URL, API };
